import { clampPivot } from "../customHooks/useZoomControls.jsx";


export const startPanning = (
  event,
  view,
  cameraContainer,
  zoom,
  isSpaceDown  
) => {
  if (!isSpaceDown) return { isPanning: false };  
  event.preventDefault();
  view.style.cursor = "grab";
  if (zoom > 1) {
    const rect = view.getBoundingClientRect();
    return {
      isPanning: true,
      startX: event.clientX - rect.left,
      startY: event.clientY - rect.top,
    };
  }
  return { isPanning: false };
};

export const movePanning = (
  event,
  state,
  view,
  cameraContainer,
  pixiCanvas,
  isSpaceDown  
) => {
  if (!state.isPanning || !isSpaceDown) return state;  
  event.preventDefault();
  view.style.cursor = "grab";

  const rect = view.getBoundingClientRect();
  const currentX = event.clientX - rect.left;
  const currentY = event.clientY - rect.top;
  const dx = currentX - state.startX;
  const dy = currentY - state.startY; 

  cameraContainer.pivot.x -= dx / cameraContainer.scale.x;
  cameraContainer.pivot.y -= dy / cameraContainer.scale.y;

  const { width: screenWidth, height: screenHeight } = pixiCanvas.screen;
  clampPivot(cameraContainer, screenWidth, screenHeight);

  return {
    isPanning: true,
    startX: currentX,
    startY: currentY,
  };
};

export const stopPanning = (state, view) => {
  if (state.isPanning) {
    view.style.cursor = "default";
  }
  return { isPanning: false };
};
